import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectIsAuthenticated } from "../../store/auth.slice";

const AuthRoute = ({ redirectRoute = "/" }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    return <Outlet />;
  }

  return <Navigate to={redirectRoute} replace />;
};
export default AuthRoute;
